export const E164_PATTERN = /^\+[1-9]\d{6,14}$/;

export function normalizePhoneDigits(phone: string): string {
  return phone.replace(/\D/g, '');
}

export function normalizeToE164(input: string): string {
  const digits = normalizePhoneDigits(input);

  if (input.trim().startsWith('+')) return `+${digits}`;
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  return digits ? `+${digits}` : '';
}
